import ActivationRule from 'owa-service/lib/contract/ActivationRule';
import ActivationRuleEvaluator from './ActivationRuleEvaluator';
import CollectionRule from 'owa-service/lib/contract/CollectionRule';
import CollectionRuleEvaluator from './CollectionRuleEvaluator';
import ItemHasAttachmentRule from 'owa-service/lib/contract/ItemHasAttachmentRule';
import ItemHasAttachmentRuleEvaluator from './ItemHasAttachmentRuleEvaluator';
import ItemHasKnownEntityRule from 'owa-service/lib/contract/ItemHasKnownEntityRule';
import ItemHasKnownEntityRuleEvaluator from './ItemHasKnownEntityRuleEvaluator';
import ItemHasRegularExpressionMatchRule from 'owa-service/lib/contract/ItemHasRegularExpressionMatchRule';
import ItemHasRegularExpressionMatchRuleEvaluator from './ItemHasRegularExpressionMatchRuleEvaluator';
import ItemIsRule from 'owa-service/lib/contract/ItemIsRule';
import ItemIsRuleEvaluator from './ItemIsRuleEvaluator';

/**
 * Creates an instance of an evaluator to evaluate the given rule
 *
 * @param rule An ActivationRule
 * @returns The ActivationRuleEvaluator for the given rule
 */
export default function createActivationRuleEvaluator(
    rule: ActivationRule
): ActivationRuleEvaluator {
    if (rule.Type == 'ItemIs') {
        return new ItemIsRuleEvaluator(rule as ItemIsRule);
    } else if (rule.Type == 'ItemHasAttachment') {
        return new ItemHasAttachmentRuleEvaluator(rule as ItemHasAttachmentRule);
    } else if (rule.Type == 'ItemHasKnownEntity') {
        return new ItemHasKnownEntityRuleEvaluator(rule as ItemHasKnownEntityRule);
    } else if (rule.Type == 'ItemHasRegularExpressionMatch') {
        return new ItemHasRegularExpressionMatchRuleEvaluator(
            rule as ItemHasRegularExpressionMatchRule
        );
    } else if (rule.Type == 'Collection') {
        return new CollectionRuleEvaluator(rule as CollectionRule);
    } else {
        throw new Error(`Rule type not supported: ${rule.Type}`);
    }
}
